import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import constants from 'styles/theme/constants';
import StyledDialogContent from 'bento-ordering/base/ui_components/StyledDialogContent';

const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    backgroundColor: 'initial',
    boxShadow: 'initial'
  }
});

const StyledDialogContentWrapper = styled(StyledDialogContent)(() => ({
  '&.MuiDialogContent-root': {
    boxShadow: constants.boxShadows.dialog
  }
}));

function OrderSettingsModal({ children, onClose, alert, alertComponent }) {
  return (
    <StyledDialog
      open={true}
      onClose={onClose}
      role="alertdialog"
      aria-label="Fulfillment method form dialog"
    >
      {// This renders the OrderAlertManager from OrderSettings
      alert && alertComponent}
      <StyledDialogContentWrapper>{children}</StyledDialogContentWrapper>
    </StyledDialog>
  );
}

OrderSettingsModal.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  onClose: PropTypes.func,
  alert: PropTypes.string,
  alertComponent: PropTypes.node
};

export default OrderSettingsModal;
